import sharesproApi from 'rtkQuery/sharespro/sharesproApiService';
import { SharesproApiResponse } from 'rtkQuery/sharespro/types/sharesproApiResponse';

export const reportsApi = sharesproApi.injectEndpoints({
  endpoints: (builder) => ({
    createReport: builder.mutation<
      SharesproApiResponse<boolean>,
      ApiCreateReportRequest
    >({
      query: (data) => ({
        url: '/private/report/billing',
        method: 'POST',
        sendToken: true,
        body: data,
      }),
    }),
  }),
});

export const { useCreateReportMutation } = reportsApi;
